import Router from '../../conversations/utils/router';
import BrowserUtils from '../utils/browser';
import CommunityActionTypes from '../types/community';
import Q from 'q';

const CommunityActions = { types: CommunityActionTypes };

CommunityActions.receiveMembers = function(members) {
  return {
    type: CommunityActions.types.RECEIVE_MEMBERS,
    members
  };
}

CommunityActions.loadingEvents = function() {
  return {
    type: CommunityActions.types.LOADING_EVENTS,
  };
}

CommunityActions.receiveEvents = function(events) {
  return {
    type: CommunityActions.types.RECEIVE_EVENTS,
    events
  };
}

CommunityActions.loadEvents = function() {
  return function(dispatch) {
    dispatch(CommunityActions.loadingEvents());
    $.ajax({
      url: Router.apiPath('events'),
      type: 'GET'
    }).then(events => {
      dispatch(CommunityActions.receiveEvents(events));
    });
  }
}

export default CommunityActions;
